import { gaCustomEvent } from "../utilities/GAUtils";
import { FormSectionElements, FormSections, ProgramContainer } from "../entities/formTemplateDataType";
import { getQuizHolderData } from "../utilities/HtmlUtils";
import { getRootComponent } from "../utilities/ElementUtils";

export type QuizGaData = {
    expectedValues: string[];
    exactValues: string[];
}

export const getQuizGaData = (section: FormSections, lang='en'): QuizGaData | undefined  => {
    const quizGAData = section.ListOfFormSubSections.reduce((sum, subSec) => {
        subSec.ListOfFormSectionElements.forEach(element => {
            if (element.Datatype === 'RadioButton') {
                if (element.ListOfExpectedValues?.length) {
                    element.ListOfExpectedValues.map(val => findOutLocaleValue(val, element, lang))
                    .filter(val => !!val)
                    .forEach(val => {
                        sum.expectedValues.push(val.trim());
                    });
                }

                const checkedValue = findOutLocaleValue(element.Value, element, lang);
                if (checkedValue) {
                    sum.exactValues.push(checkedValue.trim());
                }
            }
        });
        return sum;
    }, {expectedValues: [], exactValues: []})
    
    if (quizGAData.expectedValues.length || quizGAData.exactValues.length) {
        return quizGAData;
    }
    return undefined;
};

const findOutLocaleValue = (value: string, element: FormSectionElements, lang='en'): string |undefined => {
    if (!value) {
        return undefined;
    }
    const option = element.ListOfLOVValues.filter(item => item.code === value);
    return lang === 'en' ? option?.[0]?.description : option?.[0]?.FRADescription;
};

export const sendRatingAndFeedbackToGA = (currentSection: FormSections, trackingId?: string, lang='en') => {
    if (!trackingId) return;

    const ratings = currentSection.ListOfFormSubSections?.reduce((sum, subSec) => {
        subSec?.ListOfFormSectionElements
        ?.filter(element => (element.LoadBindName === '__feedback__' || element.Datatype === 'StarRating') && element.Value)
        .forEach(element => {
            sum.push({dataType: element.Datatype, name: lang==='en' ? element.ENUTitle: element.FRATitle, value: element.Value});
        });
        return sum;
    }, []);

    if (ratings?.length) {
        const rates = ratings.filter(item => item.dataType === 'StarRating');
        const feedbacks = ratings.filter(item => item.dataType !== 'StarRating');
        if (rates.length) {
            gaCustomEvent('Rating app', rates.reduce((sum, rating) => {
                sum[rating.name] = rating.value;
                return sum;
            }, {}), trackingId);
        }

        if (feedbacks.length) {
            gaCustomEvent('feedback', feedbacks.reduce((sum, fb) => {
                sum[fb.name] = fb.value;
                return sum;
            }, {}), trackingId);
        }
    }
}

export const sendSummaryInfoToGA = (currentSection: FormSections, lang='en') => {
    const root = getRootComponent(currentSection);
    if (!root.GATrackingID) return;
    switch(root.CategoryId) {
        case 'CPA-Quiz-Questions': return sendQuizSummaryToGA(root, currentSection, lang);
        default: break;
    }
}

const sendQuizSummaryToGA = (programContainer: ProgramContainer, section: FormSections, lang: string) => {
    const quizData = getQuizHolderData(programContainer, lang);
    if (Object.keys(quizData).length) {
        gaCustomEvent('Quiz Summary', {
            'Total questions': quizData.total, 'Correct Answers': quizData.corrected,
        }, programContainer.GATrackingID);
    }
}